Librarian.Search.Container = new Class({
    Implements: Options,
    Binds: ["onSearchLoaded", "clearSearch", "doClear", "doSearch",
            "onFileAttributesLoaded", "onSlideAttributesLoaded",
            "onGroupAttributesLoaded", "getContentElement",
            "addFileTerm", "removeFileTerm",
            "addTextTerm", "removeTextTerm",
            "addGroupTerm", "removeGroupTerm",
            "addFileKeyword", "removeFileKeyword",
            "addSlideKeyword", "removeSlideKeyword",
            "addGroupKeyword", "removeGroupKeyword",
            "addFileType", "removeFileType",
            "addFileAttribute", "removeFileAttribute",
            "addSlideAttribute", "removeSlideAttribute",
            "addGroupAttribute", "removeGroupAttribute",
            "addAttribute", "removeAttribute",
            "addElement", "removeElement"],

    options: {
        id: null,
        onSearch: $empty
    },

    datePickers: {},
    confirm: null,
    conjunctions: ["AND", "OR"],
    fileAttributes: [],
    slideAttributes: [],
    groupAttributes: [],
    fileTermCount: 1,
    textTermCount: 1,
    groupTermCount: 1,
    fileKWCount: 1,
    slideKWCount: 1,
    groupKWCount: 1,
    fileTypeCount: 1,
    fileAttCount: 1,
    slideAttCount: 1,
    groupAttCount: 1,

    defaultDateOptions: {
        timePicker: Librarian.search.searchTime,
        positionOffset: { x: 5, y: 0 },
        format: Librarian.search.searchTime ? "db" : "%m-%d-%Y"
    },

    getContentElement: function() {
        var contentEl = $(this.options.id + "_content");
        if (!contentEl)
            contentEl = $(this.options.id + "_pad");

        return contentEl;
    },

    onSearchLoaded: function(options) {
        this.setOptions(options);

        this.datePickers["minImport"] = Librarian.Utils.setUpDatePicker("minImportDate", "minImport_text", "calIconMinImport", this.options.id, this.closeDatePickers.bind(this), this.defaultDateOptions);
        this.datePickers["maxImport"] = Librarian.Utils.setUpDatePicker("maxImportDate", "maxImport_text", "calIconMaxImport", this.options.id, this.closeDatePickers.bind(this), this.defaultDateOptions);
        this.datePickers["minModified"] = Librarian.Utils.setUpDatePicker("minModifiedDate", "minMod_text", "calIconMinModified", this.options.id, this.closeDatePickers.bind(this), this.defaultDateOptions);
        this.datePickers["maxModified"] = Librarian.Utils.setUpDatePicker("maxModifiedDate", "maxMod_text", "calIconMaxModified", this.options.id, this.closeDatePickers.bind(this), this.defaultDateOptions);

        var itemEl = $("searchClear");
        if (itemEl) {
            itemEl.addOnClick(this.clearSearch);
            itemEl.id = this.options.id + "_clear";
        }

        var itemEls = this.getContentElement().getElementsByTagName("select");
        var fileAttributeRequest = null, slideAttributeRequest = null, groupAttributeRequest = null;

        // Dynamically build each select list based on what kind it is.
        for (var i = 0; i < itemEls.length; i++) {
            var options = null;

            if (itemEls[i].id.contains("_conjunction"))
                options = this.conjunctions;
            else if (itemEls[i].id.contains("_operator")) {
                options = Librarian.search.operators;
                itemEls[i].onchange = this.onOperatorChange.bind(itemEls[i]);
            }
            else if (itemEls[i].id.contains("_attribute")) {
                if (itemEls[i].id.contains("file") && (fileAttributeRequest == null)) {
                    fileAttributeRequest = new Librarian.Request.JSON({
                        url: Librarian.path.getMethodUrl("getfatl") + "&all=0&out=dgrid",
                        onFailure: Librarian.Utils.onFailure,
                        onSuccess: this.onFileAttributesLoaded
                    });
                    fileAttributeRequest.send();
                }
                else if (itemEls[i].id.contains("slide") && (slideAttributeRequest == null)) {
                    slideAttributeRequest = new Librarian.Request.JSON({
                        url: Librarian.path.getMethodUrl("getsatl") + "&all=0&out=dgrid",
                        onFailure: Librarian.Utils.onFailure,
                        onSuccess: this.onSlideAttributesLoaded
                    });
                    slideAttributeRequest.send();
                }
                else if (itemEls[i].id.contains("group") && (groupAttributeRequest == null)) {
                    groupAttributeRequest = new Librarian.Request.JSON({
                        url: Librarian.path.getMethodUrl("getgatl") + "&all=0&out=dgrid",
                        onFailure: Librarian.Utils.onFailure,
                        onSuccess: this.onGroupAttributesLoaded
                    });
                    groupAttributeRequest.send();
                }
            }
            else if (itemEls[i].id.contains("_type"))
                options = Librarian.Search.Container.fileTypeOptions;

            if (options != null) {
                itemEls[i].options.length = 0;
                itemEls[i].selectedIndex = 0;
                Librarian.Utils.fillSelect(itemEls[i], options);
            }
        }

        fileAttributeRequest = null;
        slideAttributeRequest = null;
        groupAttributeRequest = null;

        itemEls = document.getElementsByName("searchAdd");
        for (i = 0; i < itemEls.length; i++)
            itemEls[i].src = Librarian.path.getImagesPath() + "plus.jpg";

        itemEls = document.getElementsByName("searchRemove");
        for (i = 0; i < itemEls.length; i++) {
            itemEls[i].src = Librarian.path.getImagesPath() + "minus.jpg";
            Librarian.Utils.setButtonState($(itemEls[i]), null, true);
        }

        itemEl = null;
    },

    onOperatorChange: function() {
        var id = this.id.substring(0, this.id.indexOf('_') + 1);
        id += "text";
        var textEl = $(id);
        if (!textEl)
            return;

        // Multi-option boxes don't need this hidden
        if (id.startsWith("multiOption"))
            return;

        var selected = this.options[this.selectedIndex].value.trim().toUpperCase();
        if ((selected == "ISEMPTY") || (selected == "ISNOTEMPTY")) {
            textEl.value = '';
            textEl.style.visibility = "hidden";
        }
        else
            textEl.style.visibility = "inherit";
    },

    onFileAttributesLoaded: function(json) {
        if (!json || !json.data)
            return;

        var contentEl = this.getContentElement();
        if (!contentEl)
            return;

        this.fileAttributes = json.data;
        var itemEls = contentEl.getElementsByTagName("select");

        // Go through each select to find the file attributes
        for (var i = 0; i < itemEls.length; i++) {
            if (itemEls[i].id.contains("_attribute")) {
                if (itemEls[i].id.contains("file")) {
                    itemEls[i].options.length = 0;
                    itemEls[i].selectedIndex = 0;

                    Librarian.Utils.fillSelect(itemEls[i], this.fileAttributes);
                }
            }
        }
    },

    onSlideAttributesLoaded: function(json) {
        if (!json || !json.data)
            return;

        var contentEl = this.getContentElement();
        if (!contentEl)
            return;

        this.slideAttributes = json.data;
        var itemEls = contentEl.getElementsByTagName("select");

        // Go through each select to find the file attributes
        for (var i = 0; i < itemEls.length; i++) {
            if (itemEls[i].id.contains("_attribute")) {
                if (itemEls[i].id.contains("slide")) {
                    itemEls[i].options.length = 0;
                    itemEls[i].selectedIndex = 0;

                    Librarian.Utils.fillSelect(itemEls[i], this.slideAttributes);
                }
            }
        }
    },

    onGroupAttributesLoaded: function(json) {
        if (!json || !json.data)
            return;

        var contentEl = this.getContentElement();
        if (!contentEl)
            return;

        this.groupAttributes = json.data;
        var itemEls = contentEl.getElementsByTagName("select");

        // Go through each select to find the file attributes
        for (var i = 0; i < itemEls.length; i++) {
            if (itemEls[i].id.contains("_attribute")) {
                if (itemEls[i].id.contains("group")) {
                    itemEls[i].options.length = 0;
                    itemEls[i].selectedIndex = 0;

                    Librarian.Utils.fillSelect(itemEls[i], this.groupAttributes);
                }
            }
        }
    },

    closeDatePickers: function() {
        if (this.datePickers) {
            for (var key in this.datePickers) {
                if (this.datePickers[key]) {
                    this.datePickers[key].close();
                    delete this.datePickers[key];
                    this.datePickers[key] = null;
                }
            }

            this.datePickers.length = 0;
        }
    },

    addFileTerm: function() {
        var containerEl = $("fileTermContainer");
        if (!containerEl)
            return;

        this.fileTermCount++;

        this.addElement(containerEl, $("removeFileTerm"), "fileTerm", this.fileTermCount, Librarian.search.operators);
    },

    removeFileTerm: function() {
        var containerEl = $("fileTermContainer");
        if (!containerEl)
            return;

        var removeEl = $("removeFileTermButton");
        // Don't allow a removal if the button is disabled.
        if (removeEl && removeEl.hasClass("disabled"))
            return;

        this.removeElement(containerEl, removeEl, "fileTerm", this.fileTermCount);

        this.fileTermCount--;
    },

    addTextTerm: function() {
        var containerEl = $("textTermContainer");
        if (!containerEl)
            return;

        this.textTermCount++;

        this.addElement(containerEl, $("removeTextTerm"), "textTerm", this.textTermCount, Librarian.search.operators);
    },

    removeTextTerm: function() {
        var containerEl = $("textTermContainer");
        if (!containerEl)
            return;

        var removeEl = $("removeTextTermButton");
        // Don't allow a removal if the button is disabled.
        if (removeEl && removeEl.hasClass("disabled"))
            return;

        this.removeElement(containerEl, removeEl, "textTerm", this.textTermCount);

        this.textTermCount--;
    },

    addGroupTerm: function() {
        var containerEl = $("groupTermContainer");
        if (!containerEl)
            return;

        this.groupTermCount++;

        this.addElement(containerEl, $("removeGroupTerm"), "groupTerm", this.groupTermCount, Librarian.search.operators);
    },

    removeGroupTerm: function() {
        var containerEl = $("groupTermContainer");
        if (!containerEl)
            return;

        var removeEl = $("removeGroupTermButton");
        // Don't allow a removal if the button is disabled.
        if (removeEl && removeEl.hasClass("disabled"))
            return;

        this.removeElement(containerEl, removeEl, "groupTerm", this.groupTermCount);

        this.groupTermCount--;
    },

    addFileKeyword: function() {
        var containerEl = $("fileKWContainer");
        if (!containerEl)
            return;

        this.fileKWCount++;

        this.addElement(containerEl, $("removeFileKW"), "fileKW", this.fileKWCount, Librarian.search.operators);
    },

    removeFileKeyword: function() {
        var containerEl = $("fileKWContainer");
        if (!containerEl)
            return;

        var removeEl = $("removeFileKWButton");
        // Don't allow a removal if the button is disabled.
        if (removeEl && removeEl.hasClass("disabled"))
            return;

        this.removeElement(containerEl, removeEl, "fileKW", this.fileKWCount);

        this.fileKWCount--;
    },

    addSlideKeyword: function() {
        var containerEl = $("slideKWContainer");
        if (!containerEl)
            return;

        this.slideKWCount++;

        this.addElement(containerEl, $("removeSlideKW"), "slideKW", this.slideKWCount, Librarian.search.operators);
    },

    removeSlideKeyword: function() {
        var containerEl = $("slideKWContainer");
        if (!containerEl)
            return;

        var removeEl = $("removeSlideKWButton");
        // Don't allow a removal if the button is disabled.
        if (removeEl && removeEl.hasClass("disabled"))
            return;

        this.removeElement(containerEl, removeEl, "slideKW", this.slideKWCount);

        this.slideKWCount--;
    },

    addGroupKeyword: function () {
        var containerEl = $("groupKWContainer");
        if (!containerEl)
            return;

        this.groupKWCount++;

        this.addElement(containerEl, $("removeGroupKW"), "groupKW", this.groupKWCount, Librarian.search.operators);
    },

    removeGroupKeyword: function () {
        var containerEl = $("groupKWContainer");
        if (!containerEl)
            return;

        var removeEl = $("removeGroupKWButton");
        // Don't allow a removal if the button is disabled.
        if (removeEl && removeEl.hasClass("disabled"))
            return;

        this.removeElement(containerEl, removeEl, "groupKW", this.groupKWCount);

        this.groupKWCount--;
    },

    addFileType: function() {
        var containerEl = $("fileTypeContainer");
        if (!containerEl)
            return;

        this.fileTypeCount++;

        // Default to the list of options
        var options = Librarian.Search.Container.fileTypeOptions;

        var typeEl = $("fileType1_type");
        // If the first type is an input, get its value as the only option
        if (typeEl && (typeEl.tagName == "INPUT"))
            options = typeEl.value;

        this.addElement(containerEl, $("removeFileType"), "fileType", this.fileTypeCount, options, "type", $("fileType1_select"));

        var excludeCheckEl = new Element("input");
        excludeCheckEl.type = "checkbox";
        excludeCheckEl.id = "fileType" + this.fileTypeCount + "_check";

        var excludeTextEl = new Element("span", {
            text: " Exclude"
        });

        var excludeLabelEl = new Element("label");
        excludeLabelEl.appendChild(excludeCheckEl);
        excludeLabelEl.appendChild(excludeTextEl);
        excludeLabelEl.addClass("dialogitem");
        excludeLabelEl.id = "fileType" + this.fileTypeCount + "_label";

        containerEl.appendChild(excludeLabelEl);

        // Move the clear element to the end
        var breakEl = $("fileType" + this.fileTypeCount + "_clear");
        if (breakEl)
            containerEl.appendChild(containerEl.removeChild(breakEl));
    },

    removeFileType: function() {
        var containerEl = $("fileTypeContainer");
        if (!containerEl)
            return;

        var removeEl = $("removeFileTypeButton");
        // Don't allow a removal if the button is disabled.
        if (removeEl && removeEl.hasClass("disabled"))
            return;

        this.removeElement(containerEl, removeEl, "fileType", this.fileTypeCount);

        var labelEl = $("fileType" + this.fileTypeCount + "_label");
        if (labelEl)
            containerEl.removeChild(labelEl).destroy();

        this.fileTypeCount--;
    },

    addFileAttribute: function() {
        var containerEl = $("fileAttContainer");
        if (!containerEl)
            return;

        this.fileAttCount++;

        this.addAttribute(containerEl, $("removeFileAtt"), this.fileAttributes, "file", this.fileAttCount);
    },

    removeFileAttribute: function() {
        var containerEl = $("fileAttContainer");
        if (!containerEl)
            return;

        var removeEl = $("removeFileAttButton");
        // Don't allow a removal if the button is disabled.
        if (removeEl && removeEl.hasClass("disabled"))
            return;

        this.removeAttribute(containerEl, removeEl, "file", this.fileAttCount);

        this.fileAttCount--;
    },

    addSlideAttribute: function() {
        var containerEl = $("slideAttContainer");
        if (!containerEl)
            return;

        this.slideAttCount++;

        this.addAttribute(containerEl, $("removeSlideAtt"), this.slideAttributes, "slide", this.slideAttCount);
    },

    removeSlideAttribute: function() {
        var containerEl = $("slideAttContainer");
        if (!containerEl)
            return;

        var removeEl = $("removeSlideAttButton");
        // Don't allow a removal if the button is disabled.
        if (removeEl && removeEl.hasClass("disabled"))
            return;

        this.removeAttribute(containerEl, removeEl, "slide", this.slideAttCount);

        this.slideAttCount--;
    },

    addGroupAttribute: function() {
        var containerEl = $("groupAttContainer");
        if (!containerEl)
            return;

        this.groupAttCount++;

        this.addAttribute(containerEl, $("removeGroupAtt"), this.groupAttributes, "group", this.groupAttCount);
    },

    removeGroupAttribute: function() {
        var containerEl = $("groupAttContainer");
        if (!containerEl)
            return;

        var removeEl = $("removeGroupAttButton");
        // Don't allow a removal if the button is disabled.
        if (removeEl && removeEl.hasClass("disabled"))
            return;

        this.removeAttribute(containerEl, removeEl, "group", this.groupAttCount);

        this.groupAttCount--;
    },

    addAttribute: function(containerEl, removeEl, attributes, type, count) {
        if (!containerEl)
            return;

        var selectEl = new Element("select");
        selectEl.id = type + "Att" + count + "_attribute";
        selectEl.addClass("left").addClass("dialogitem");

        Librarian.Utils.fillSelect(selectEl, attributes);

        containerEl.appendChild(selectEl);

        this.addElement(containerEl, removeEl, type + "Att", count, Librarian.search.operators);
    },

    removeAttribute: function(containerEl, removeEl, type, count) {
        if (!containerEl)
            return;

        var attEl = $(type + "Att" + count + "_attribute");
        if (attEl)
            containerEl.removeChild(attEl).destroy();

        this.removeElement(containerEl, removeEl, type + "Att", count);
    },

    addElement: function(containerEl, removeEl, type, count, options, selectIDSuffix, sourceEl) {
        if (!containerEl)
            return;

        if ((typeof selectIDSuffix == "undefined") || (selectIDSuffix == null))
            selectIDSuffix = "operator";

        var itemEl;
        // If we have a source and it's a select, copy it
        if ((typeof sourceEl != "undefined") && (sourceEl != null) && (sourceEl.tagName == "SELECT")) {
            itemEl = new Element("select");

            // Add all the existing options
            for (var i = 0; i < sourceEl.options.length; i++) {
                var optionEl = new Option(sourceEl.options[i].text, sourceEl.options[i].value);
                itemEl.options.add(optionEl);
            }

            itemEl.addClass("dialogitem").addClass("dialogselect");
            itemEl.id = type + count + "_select";
        }
        else {
            itemEl = new Element("input");
            itemEl.type = "text";
            itemEl.autocorrect = "off";
            itemEl.autocapitalize = "off";
            itemEl.id = type + count + "_text";
            itemEl.addClass("dialogitem");
            itemEl.onkeydown = function(e) {
                var evt = new Event(e);
                if (evt.keyCode == 13)
                    this.search();
                evt = null;
            };
        }

        if (options != null) {
            // If there are multiple options, make a select
            if (typeOf(options) == "array") {
                var selectEl = new Element("select");
                selectEl.id = type + count + '_' + selectIDSuffix;
                selectEl.addClass("left").addClass("dialogitem");

                if (selectIDSuffix == "operator")
                    selectEl.onchange = this.onOperatorChange.bind(selectEl);

                for (var i = 0; i < options.length; i++) {
                    var optionEl;

                    if ((typeOf(options[i]) == "array") && options[i].length > 1)
                        optionEl = new Option(options[i][0], options[i][1]);
                    else
                        optionEl = new Option(options[i], options[i]);

                    selectEl.options.add(optionEl);
                }

                containerEl.appendChild(selectEl);

                selectEl = null;
            }
            // Otherwise, make an input
            else {
                var inputEl = new Element("input[type=hidden]");
                inputEl.value = options;
                inputEl.id = type + count + '_' + selectIDSuffix;

                containerEl.appendChild(inputEl);

                inputEl = null;
            }
        }

        var clearEl = new Element("div");
        clearEl.id = type + count + "_clear";
        clearEl.style.clear = "both";

        containerEl.appendChild(itemEl);
        containerEl.appendChild(clearEl);

        if (removeEl) {
            var buttonEl = $(removeEl.id + "Button");
            if (buttonEl && buttonEl.hasClass("disabled"))
                Librarian.Utils.setButtonState(buttonEl, removeEl, false);
            buttonEl = null;
        }

        itemEl = null;
        clearEl = null;
        containerEl = null;
        removeEl = null;
    },

    removeElement: function(containerEl, removeEl, type, count) {
        if (!containerEl)
            return;

        var childEl = $(type + count + "_text");
        if (childEl)
            containerEl.removeChild(childEl).destroy();

        childEl = $(type + count + "_select");
        if (childEl)
            containerEl.removeChild(childEl).destroy();

        childEl = $(type + count + "_operator");
        if (childEl)
            containerEl.removeChild(childEl).destroy();

        childEl = $(type + count + "_type");
        if (childEl)
            containerEl.removeChild(childEl).destroy();

        childEl = $(type + count + "_clear");
        if (childEl)
            containerEl.removeChild(childEl).destroy();

        if (removeEl) {
            if ((count - 1) == 1) {
                var buttonEl = $(removeEl.id);
                if (buttonEl)
                    Librarian.Utils.setButtonState(buttonEl, removeEl, true);
            }
        }
    },

    clearSearch: function() {
        // Make sure the user wants to do this first
        this.confirm = new Librarian.ConfirmWindow({
            id: "clearSearchConfirmWindow",
            title: Librarian.Lang.getString("search_clear"),
            question: Librarian.Lang.getString("search_clear?")
        });
        this.confirm.onFirstButtonClicked = this.doClear.bind(this);
        this.confirm.show();
    },

    doClear: function() {
        // Remove all the added boxes
        while (this.fileTermCount > 1)
            this.removeFileTerm();
        while (this.textTermCount > 1)
            this.removeTextTerm();
        while (this.groupTermCount > 1)
            this.removeGroupTerm();
        while (this.fileKWCount > 1)
            this.removeFileKeyword();
        while (this.slideKWCount > 1)
            this.removeSlideKeyword();
        while (this.groupKWCount > 1)
            this.removeGroupKeyword();
        while (this.fileTypeCount > 1)
            this.removeFileType();
        while (this.fileAttCount > 1)
            this.removeFileAttribute();
        while (this.slideAttCount > 1)
            this.removeSlideAttribute();
        while (this.groupAttCount > 1)
            this.removeGroupAttribute();

        var contentEl = this.getContentElement();
        if (!contentEl)
            return;

        // Get all the selects within the search page
        var items = contentEl.getElementsByTagName("select");

        // Set the first option selected for every select
        for (var i = 0; i < items.length; i++)
            items[i].options[0].selected = true;

        // Get all the inputs within the search page
        items = contentEl.getElementsByTagName("input");

        // Reset each input correctly based on their type
        for (i = 0; i < items.length; i++) {
            if (items[i].type == "text")
                items[i].value = '';
            else if (items[i].type == "checkbox")
                items[i].checked = false;
        }

        // Get all the forms within the search page
        items = contentEl.getElementsByTagName("form");

        // Reset every form
        for (i = 0; i < items.length; i++)
            items[i].reset();
    },

    doSearch: function() {
        // If there's no search, we can't continue.
        if (!Librarian.Search) {
            Librarian.Utils.error(Librarian.Lang.getString("search_unavailable"));
            return;
        }

        // Build the search object
        var search = new Librarian.Search();

        var globalConjunctionEl = $("globalOverride_conjunction");
        var globalConjunction = null;
        // If there is a global conjunction selector, get the value
        if (globalConjunctionEl) {
            // If it's a select box, just get the selected value
            if (globalConjunctionEl.tagName == "SELECT")
                globalConjunction = globalConjunctionEl.options[globalConjunctionEl.selectedIndex].value;
            // Otherwise, it should be a form. Find the first checked radio box.
            else {
                for (var i = 0; (globalConjunction == null) && (i < globalConjunctionEl.conjunction.length) ; i++) {
                    if (globalConjunctionEl.conjunction[i].checked)
                        globalConjunction = globalConjunctionEl.conjunction[i].value;
                }
            }
        }

        // Add the terms and keywords
        var searched = this.addSearchNode("fileTerm", search.addFileTerm, this.getTermFlags("fileTerm", Librarian.Search.Container.fileTermFlags), globalConjunction);
        searched = searched && this.addSearchNode("bothTerm", search.addFileTerm, this.getTermFlags("fileTerm", Librarian.Search.Container.fileTermFlags), globalConjunction);
        searched = searched && this.addSearchNode("textTerm", search.addTextTerm, this.getTermFlags("textTerm", Librarian.Search.Container.textTermFlags), globalConjunction);
        searched = searched && this.addSearchNode("bothTerm", search.addTextTerm, this.getTermFlags("textTerm", Librarian.Search.Container.textTermFlags), globalConjunction);
        searched = searched && this.addSearchNode("groupTerm", search.addGroupTerm, globalConjunction);
        searched = searched && this.addSearchNode("fileKW", search.addFileKeyword, globalConjunction);
        searched = searched && this.addSearchNode("slideKW", search.addSlideKeyword, globalConjunction);
        searched = searched && this.addSearchNode("groupKW", search.addGroupKeyword, globalConjunction);

        // Selected file type search type
        var type = null;
        // Whether or not "Exclude" is checked
        var check = false;

        // Selected conjunction for this search item
        var conjunctionEl = $("fileType_conjunction");
        // Get the selected conjunction if it's available
        var conjunction = globalConjunction;
        if (conjunctionEl)
            conjunction = conjunctionEl.options[conjunctionEl.selectedIndex].value;

        var itemEl, selectEl;
        var continueSearch = true;
        // For each file type
        for (i = 1; continueSearch; i++) {
            // Get the selected search type, if it's available.
            itemEl = $("fileType" + i + "_type");
            if (itemEl) {
                if (itemEl.tagName == "SELECT")
                    type = itemEl.options[itemEl.selectedIndex].value;
                else if (itemEl.tagName == "INPUT")
                    type = itemEl.value;
            }

            // Get the exclude value if it's available
            itemEl = $("fileType" + i + "_check");
            if (itemEl)
                check = itemEl.checked;

            // Check if there is a text box, just in case
            itemEl = $("fileType" + i + "_text");
            selectEl = $("fileType" + i + "_select");
            if (itemEl) {
                // Don't add a file type without a value
                if (itemEl.value.length > 0) {
                    // If this fails to add the file type, its usually because the
                    // file type ID was invalid. Display a message to the user
                    if (!search.addFileType(type, itemEl.value, check, conjunction)) {
                        var searchErrorWindow = new Librarian.ConfirmWindow({
                            title: Librarian.Lang.getString("search_invalid_type_title"),
                            question: Librarian.Lang.getString("search_invalid_type_message"),
                            firstButtonText: Librarian.Lang.getString("ok"),
                            useSecondButton: false
                        });
                        searchErrorWindow.show();
                        search.destroy();
                        return;
                    }
                }
            }
            else if (selectEl) {
                var value = selectEl.options[selectEl.selectedIndex].value;
                // Don't add a file type without a value
                if (value && (value.length > 0)) {
                    // If this fails to add the file type, its usually because the
                    // file type ID was invalid. Display a message to the user
                    if (!search.addFileType(type, value, check, conjunction)) {
                        var searchErrorWindow = new Librarian.ConfirmWindow({
                            title: Librarian.Lang.getString("search_invalid_type_title"),
                            question: Librarian.Lang.getString("search_invalid_type_message"),
                            firstButtonText: Librarian.Lang.getString("ok"),
                            useSecondButton: false
                        });
                        searchErrorWindow.show();
                        search.destroy();
                        return;
                    }
                }
            }
                // Stop checking for values if the last one didn't exist
            else
                continueSearch = false;

            itemEl = null;
            selectEl = null;
        }

        // Add the attributes
        searched = searched && this.addSearchNode("fileAtt", search.addFileAttribute, null, globalConjunction);
        searched = searched && this.addSearchNode("slideAtt", search.addSlideAttribute, null, globalConjunction);
        searched = searched && this.addSearchNode("groupAtt", search.addGroupAttribute, null, globalConjunction);

        // Add the dates
        searched = searched && this.addSearchDate("minMod_text", search.addMinModifiedDate);
        searched = searched && this.addSearchDate("maxMod_text", search.addMaxModifiedDate);
        searched = searched && this.addSearchDate("minImport_text", search.addMinImportDate);
        searched = searched && this.addSearchDate("maxImport_text", search.addMaxImportDate);

        var pageName = '';
        itemEl = $("searchTargetForm");
        // If the search target is on this page,
        // add the value as a category ID for this search
        if (itemEl) {
            var value, values;
            for (var i = 0; i < itemEl.searchTarget.length; i++) {
                value = itemEl.searchTarget[i].value;

                if (itemEl.searchTarget[i].checked) {
                    if (itemEl.searchTarget[i].pageName == "All") {
                        values = value.split(';');

                        for (var j = 0; j < values.length; j++) {
                            value = Librarian.Search.extractAndPrepCategory(search, values[j]);
                            searched = searched && search.addCategory(value);
                        }
                    }
                    else {
                        value = Librarian.Search.extractAndPrepCategory(search, value);
                        searched = searched && search.addCategory(value);
                    }

                    // Store the given page name
                    pageName = itemEl.searchTarget[i].pageName;
                }
            }
        }

        itemEl = $("searchOutputsForm");
        var outputType = Librarian.search.defaultOutputType;
        if (itemEl) {
            // Loop through the search output options
            // and store the chosen one as the actual result output.
            for (var i = 0; i < itemEl.searchOutput.length; i++) {
                if (itemEl.searchOutput[i].checked) {
                    if (itemEl.searchOutput[i].value == "files")
                        outputType = Librarian.Search.outputTypes.FILES;
                    else if (itemEl.searchOutput[i].value == "slides")
                        outputType = Librarian.Search.outputTypes.SLIDES;
                    else
                        outputType = Librarian.Search.outputTypes.GROUPS;

                    break;
                }
            }
        }

        // Get all custom meta elements
        var customMetaEls = $$(document.getElementsByName("customMeta"));
        for (var i = 0; i < customMetaEls.length; i++) {
            var attribute = customMetaEls[i].meta;

            if (!attribute || (attribute.trim().length == 0))
                continue;

            var operator = customMetaEls[i].operator;
            var type = customMetaEls[i].outputType;
            var filterConjunction = customMetaEls[i].filterConjunction;
            var func;

            // Determine which type they are based on the selected output type
            if ((typeof type == "string") && (type != null) && (type.trim().length > 0)) {
                type = type.trim().toUpperCase();
                if (type.startsWith("FILE"))
                    func = search.addFileAttribute;
                else if (type.startsWith("SLIDE"))
                    func = search.addSlideAttribute;
                else if (type.startsWith("GROUP"))
                    func = search.addGroupAttribute;
                else
                    continue;
            }
            else {
                if (outputType == Librarian.Search.outputTypes.FILES)
                    func = search.addFileAttribute;
                else if (outputType == Librarian.Search.outputTypes.SLIDES)
                    func = search.addSlideAttribute;
                else if (outputType == Librarian.Search.outputTypes.GROUPS)
                    func = search.addGroupAttribute;
                else
                    continue;
            }

            var value = null, prep = true;
            // Get the value depending on what type of element it is
            if (customMetaEls[i].tagName == "SELECT") {
                value = customMetaEls[i].options[customMetaEls[i].selectedIndex].value;
                prep = false;
            }
            else if (customMetaEls[i].tagName == "INPUT") {
                if (customMetaEls[i].type == "text")
                    value = customMetaEls[i].value;
                else if (customMetaEls[i].type == "checkbox")
                    value = customMetaEls[i].checked.toString();
            }

            // If this is null or an empty value (and this isn't an IsEmpty operator which has no value
            // then skip this one because it shouldn't be included
            if ((value == null) || ((operator != "IsEmpty") && (operator != "IsNotEmpty") && (value.trim().length == 0)))
                continue;

            if (prep)
                value = Librarian.Search.prepValue(value, (operator != "Contains"));

            searched = searched && func(value, globalConjunction, operator, attribute, filterConjunction);
        }

        var multiOptionEls = $$(document.getElementsByName("multiOption"));
        for (var i = 0; i < multiOptionEls.length; i++) {
            if (!multiOptionEls[i].searchTypes)
                continue;

            var outputTypes = [];

            if (multiOptionEls[i].outputTypes)
                outputTypes = multiOptionEls[i].outputTypes.split(',');
            else
                outputTypes.push(outputType);

            var searchTypes = multiOptionEls[i].searchTypes.split(',');

            for (var j = 0; j < outputTypes.length; j++) {
                for (var k = 0; k < searchTypes.length; k++) {
                    var type;

                    if (outputTypes[j].toInt() == Librarian.Search.outputTypes.FILES)
                        type = "File";
                    else if (outputTypes[j].toInt() == Librarian.Search.outputTypes.SLIDES) {
                        if (searchTypes[k] == "Term")
                            type = "Text";
                        else
                            type = "Slide";
                    }
                    else if (outputTypes[j].toInt() == Librarian.Search.outputTypes.GROUPS)
                        type = "Group";
                    else
                        continue;

                    var func = eval("search.add" + type + searchTypes[k]);

                    var id = multiOptionEls[i].id;
                    id = id.substring(0, id.indexOf('_') + 1);

                    var operatorEl = $(id + "operator");
                    var operator = null;
                    if (operatorEl) {
                        // Get the operator depending on what type of element it is
                        if (operatorEl.tagName == "SELECT")
                            operator = operatorEl.options[operatorEl.selectedIndex].value;
                        else if (operatorEl.tagName == "INPUT")
                            operator = operatorEl.value;
                    }

                    var value = null, prep = true;
                    // Get the value depending on what type of element it is
                    if (multiOptionEls[i].tagName == "SELECT") {
                        value = multiOptionEls[i].options[multiOptionEls[i].selectedIndex].value;
                        prep = false;
                    }
                    else if (multiOptionEls[i].tagName == "INPUT") {
                        if (multiOptionEls[i].type == "text")
                            value = multiOptionEls[i].value;
                        else if (multiOptionEls[i].type == "checkbox")
                            value = multiOptionEls[i].checked.toString();
                    }

                    // If this is null or an empty value (and this isn't an IsEmpty operator which has no value
                    // then skip this one because it shouldn't be included
                    if ((value == null) || ((operator != "IsEmpty") && (operator != "IsNotEmpty") && (value.trim().length == 0)))
                        continue;

                    // Keywords get special treatment for preperation
                    if (searchTypes[k] == "Keyword") {
                        var match = value.match(/"/g);

                        // If there are quotes
                        if (match && (match.length > 0)) {
                            // And there are multiple sets of quotes, use the prepared value
                            // IE: "a b" "c"
                            if (match.length > 2)
                                prep = true;
                                // Otherwise only use prepared value if there are 2 quotes but the entire string isn't quoted
                                // IE: "a b" c
                            else if (!value.isQuoted())
                                prep = true;
                                // If there are exactly 2 quotes and they surround this phrase, don't prepare it
                            else
                                prep = false;
                        }
                            // If there are no quotes, don't prepare at all
                        else
                            prep = false;
                    }

                    // Prepare the value if and only if we should
                    if (prep)
                        value = Librarian.Search.prepValue(value, (operator != "Contains"));

                    var attribute = null;
                    // If this is a term, get the correct flags
                    if (searchTypes[k] == "Term") {
                        if (type == "File")
                            attribute = this.getTermFlags("fileTerm", Librarian.Search.Container.fileTermFlags);
                        else if (type == "Text")
                            attribute = this.getTermFlags("textTerm", Librarian.Search.Container.textTermFlags);
                    }

                    searched = searched && func(value, globalConjunction, operator, attribute);
                }
            }
        }

        search.deleteEmptyFilters();

        if (Librarian.guestInfo) {
            // Limit search to content available to guest
            var contactId = Librarian.guestInfo.ContactId.toString() || '';
            var contactType = Librarian.guestInfo.ContactType.toString() || '';
            var eventId = null;

            // Limit search to content for this event, if there is one
            if (Librarian.eventInfo)
                eventId = Librarian.eventInfo.EventId.toString() || '';

            searched = searched && search.addContent(eventId, contactId, contactType, "OR");
        }

        itemEl = null;

        var maxResults = Librarian.search.maxResults;

        // Use the ListView handler, if it's enabled
        if (Librarian.listView.enabled && Librarian.ListView != null && (typeof Librarian.ListView.prepSearchGrid == "function"))
            maxResults = Librarian.ListView.prepSearchGrid(search, outputType);
        else
            search.options.loadComplete = tileList.searchLoadComplete;

        var viewName = null;
        if ((typeOf(Librarian.search.viewNameByType) == "array") && (Librarian.search.viewNameByType.length > outputType))
            viewName = Librarian.search.viewNameByType[outputType];

        // Set the max results, output type, and view name
        searched = searched && search.addResults(null, maxResults, outputType, null, null, viewName);

        if (searched) {
            // Store this as the last search so we can use pagination
            Librarian.lastSearch = search;

            // Don't call the function if it doesn't exist
            if (typeof Library.prepSearchPage == "function")
                Library.prepSearchPage(pageName, Librarian.Lang.getString("search_advanced"));

            // Reset the hash
            Librarian.Utils.changeHash('');

            // Execute the search
            search.search();

            // Call the onSearch function, if it's valid
            if (typeof this.options.onSearch == "function")
                this.options.onSearch();
        }
    },

    addSearchNode: function(prefix, func, attribute, globalConjunction) {
        if (typeof globalConjunction == "undefined")
            globalConjunction = null;

        // Selected operator for this search item
        var operator = null;
        var itemEl;
        var conjunction = null;
        var continueSearch = true;
        var valid = true;

        var conjunctionEl = $(prefix + "_conjunction");
        // Get the selected conjunction if it's available
        if (conjunctionEl) {
            // If it's a select box, just get the selected value
            if (conjunctionEl.tagName == "SELECT")
                conjunction = conjunctionEl.options[conjunctionEl.selectedIndex].value;
            // Otherwise, it should be a form. Find the first checked radio box.
            else {
                for (var i = 0; (conjunction == null) && (i < conjunctionEl.conjunction.length) ; i++) {
                    if (conjunctionEl.conjunction[i].checked)
                        conjunction = conjunctionEl.conjunction[i].value;
                }
            }
        }

        // If we didn't find a conjunction, use the one that was given
        if (!conjunction)
            conjunction = globalConjunction;

        // For each item
        for (i = 1; continueSearch; i++) {
            // Default to the given attribute
            var nodeAttribute = attribute;

            // Get the selected operator if it's available
            itemEl = $(prefix + i + "_operator");
            if (itemEl)
                operator = Librarian.Utils.getElementValue(itemEl);

            // If we aren't given an attribute already
            if (!nodeAttribute) {
                // Get the selected attribute if it's available
                itemEl = $(prefix + i + "_attribute");
                if (itemEl)
                    nodeAttribute = Librarian.Utils.getElementValue(itemEl);
            }

            // Check if there is a text box, just in case
            itemEl = $(prefix + i + "_text");
            if (itemEl) {
                // Don't add a search attribute without a value
                if ((itemEl.value.length > 0) || Librarian.search.emptyValueOperators.contains(operator)) {
                    var value = itemEl.value;

                    // Prep the search value, but not for keywords
                    if (!prefix.contains("KW"))
                        value = Librarian.Search.prepValue(value, (operator != "Contains"));

                    valid = func(value, conjunction, operator, nodeAttribute);
                }
            }
                // Stop checking for values if the last one didn't exist
            else
                continueSearch = false;
        }

        return valid;
    },

    addSearchDate: function(id, func) {
        var valid = true;

        // If this element exists and it has a value, add it
        var itemEl = $(id);
        if (itemEl && (itemEl.value.length > 0))
            valid = func(itemEl.value);

        return valid;
    },

    getTermFlags: function(prefix, options) {
        var optionEl;
        var flags = -1;
        var checkedCount = 0;
        // Get the search options element if it is available
        var itemEl = $(prefix + "Options");

        // If this is a form with elements in it
        if (itemEl && itemEl.elements && itemEl.elements.length && !itemEl.disabled) {
            // Check for each of the given options
            for (var j = 0; j < options.length; j++) {
                // Make sure this is an array
                if (typeOf(options[j]) == "array") {
                    // If there is an element with the specified name
                    optionEl = itemEl.elements[options[j][0]];

                    if (optionEl) {
                        // And it's checked
                        if (optionEl.checked) {
                            // Make sure the flags are set to "0"
                            // if they havent been used yet
                            if (flags < 0)
                                flags = 0;

                            checkedCount++;

                            // And add the flag value
                            flags += options[j][1];
                        }
                    }
                }
            }

            // If every option was checked and we have the option set to search everything,
            // set the flags to -1 so everything is searched.
            if ((checkedCount == itemEl.elements.length) && Librarian.search.searchAllFlagsIfAllOptionsChecked)
                flags = -1;
        }

        return flags;
    }
});

Librarian.Search.Container.extend({
    fileTypeOptions: [["File Type (Name)", "name"], ["File Type (Extension)", "extension"], ["File Type (ID)", "id"], ["File Sub-Type", "subType"]],
    fileTermFlags: [["name", 1], ["title", 2], ["description", 4]],
    groupTermFlags: [["name", 1], ["description", 2]],
    eventGroupTermFlags: [["name", 1], ["description", 2]],
    textTermFlags: [["titles", 1], ["notes", 2], ["bullets", 4], ["text", 8], ["fileKW", 16], /*"File Keyword" ["obsolete", 32],*/["slideKW", 64], ["wordFile", 128], ["excelFile", 256], ["pdfFile", 512], ["textFile", 1024], ["rtfFile", 2048], ["url", 4096], ["description", 8192]],

    getFlagValue: function(flags, name) {
        if (!flags || (typeof name != "string"))
            return 0;

        for (var i = flags.length; i--;) {
            var flagName = flags[i][0];
            if (flagName == name)
                return flags[i][1];
        }

        return 0;
    }
});